export const defaultSections = [
  {
    id: 1,
    title: "व्यक्तिगत विवरण",
    fields: [
      { id: 1, label: "नाम", value: "नाम भरें" },
      { id: 2, label: "जन्म तिथि", value: "जन्म तिथि भरें" },
      { id: 3, label: "जन्म समय", value: "जन्म समय भरें" },
      { id: 4, label: "जन्म स्थान", value: "जन्म स्थान भरें" },
      { id: 5, label: "शिक्षा", value: "शिक्षा भरें" },
      { id: 6, label: "व्यवसाय", value: "व्यवसाय भरें" },
      { id: 7, label: "आय", value: "आय भरें" }
    ]
  },
  {
    id: 2,
    title: "परिवार के सदस्य",
    fields: [
      { id: 8, label: "पिताजी का नाम", value: "पिताजी का नाम भरें" },
      { id: 9, label: "पिताजी का व्यवसाय", value: "पिताजी का व्यवसाय भरें" },
      { id: 10, label: "माताजी का नाम", value: "माताजी का नाम भरें" },
      { id: 11, label: "माताजी का व्यवसाय", value: "माताजी का व्यवसाय भरें" }
    ]
  },
  {
    id: 3,
    title: "संपर्क सूत्र",
    fields: [
      { id: 12, label: "नाम", value: "नाम भरें" },
      { id: 13, label: "फ़ोन नंबर", value: "फ़ोन नंबर भरें" },
      { id: 14, label: "पता", value: "पता भरें" }
    ]
  }
];